<template>
    <!-- 방문 신청정보 입력 폼 -->
    <VisitInfoForm ref="refVisitInfoForm" :visitData="visitData" />
</template>

<script>
import VisitInfoForm from "./mrVisitForm/comp/VisitInfoForm.vue";
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    VisitInfoForm,
    ConfirmDialog,
  },
  props: {
    visitData: {
      type: Object,
    },
  },
  methods: {
  },
};
</script>

